'use strict';

/**
 * Referral code tooltip is handled by the existing g-tooltip CSS pattern.
 * No JS initialisation required.
 */
function initTooltip() {}

module.exports = {
    init: initTooltip
};
